import * as React from "react";
import {ChevronRight} from "@mui/icons-material";
import {Link} from "react-router-dom";
import Box from "@mui/material/Box";
import {PageItem} from "../../../Components/PageItem";
import Button from "@mui/material/Button";
import {PageOuterContainer} from "../../../Components/PageOuterContainer";
import {AverageRecurringExpenses} from "./AverageRecurringExpenses";

interface IContainerProps {
    smallScreen: boolean;
    children: React.ReactNode;
}

export const Container = ({smallScreen, children}: IContainerProps) => {
    if (smallScreen) {
        return (
            <div>
                {children}
            </div>
        )
    }

    return (
        <PageOuterContainer>
            <PageItem
                title="Recurring Expenses List"
                actions={
                    <Button
                        component={Link}
                        size="small"
                        endIcon={<ChevronRight />}
                        to="/recurring-expenses/new"
                    >
                        Add new recurring expense
                    </Button>
                }
            >
                <AverageRecurringExpenses />

                <Box sx={{display: 'flex', flexGrow: 1}}>
                    {children}
                </Box>
            </PageItem>
        </PageOuterContainer>
    )
};
